<template>
  <!--  <div
    :style="{
      'background-image': 'url(' + require('@/assets/simepar_bg_4.png') + ')',
      'background-repeat': 'no-repeat',
      'background-size': '100%',
      display: 'flex',
      'flex-direction': 'row',
      'align-items': 'center',
      padding: '80px 0px 80px 222px',
      width: '1600px',
      height: '725px',
      left: '4px',
      top: '4278px',
    }"
  >-->
  <!--</div>-->
  <v-row no-gutters>
    <!--<v-img max-height="725" :src="require('@/assets/simepar_bg_4.png')">-->
      <v-container fill-height>
        <v-row align="center" class="white--text mx-auto" justify="center">
          <v-col cols="6">
            <v-card-title>
              <h1 class="simepar-title">Simepar</h1>
            </v-card-title>
            <v-card-text>
              <p class="simepar-title-text">
                Uma equipe altamente qualificada, que combina tecnologia e um
                modelo de gestão empresarial orientado para a qualidade e
                inovação com responsabilidade social.
              </p>
            </v-card-text>
            <v-card-title>
              <h1 class="simepar-subtitle">Excelência tecnológica</h1>
            </v-card-title>
            <v-card-text class="ml-5">
              <v-icon>mdi-circle</v-icon>
              <p class="simepar-subtitle-text">
                Previsões realizadas com base em telemetria e sensoriamento
                automático de dados
              </p>
              <v-icon>mdi-circle</v-icon>
              <p class="simepar-subtitle-text">
                Modelos númericos e análise crítica de profissionais capacitados
              </p>
              <v-icon>mdi-circle</v-icon>
              <p class="simepar-subtitle-text">
                Modernos equipamentos e sistemas computacionais inteligentes
                viabilizam a recepção, o processamento e a disseminação de dados
                e informações em tempo real
              </p>
            </v-card-text>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-avatar size="340px" class="ml-6">
              <v-img :src="require('@/assets/arte.png')" alt="Arte Infohidro"></v-img>
            </v-avatar>
          </v-col>
        </v-row>
      </v-container>
    <!--</v-img>-->
  </v-row>
  <!--  </div>-->
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style scoped>
@font-face {
  font-family: 'Poppins';
  src: local('Poppins'), url('../../assets/fonts/Poppins/Poppins-SemiBold.ttf') format("truetype");
}

@font-face {
  font-family: 'Questrial';
  src: local('Questrial'), url('../../assets/fonts/Questrial/Questrial-Regular.ttf') format("truetype");
}

.simepar-title {
  /*position: absolute*;*/
  width: 125px;
  height: 33px;
  left: 0px;
  top: 5px;

  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 33px;

  display: flex;
  align-items: center;

  color: #ffffff;
}

.simepar-title-text {
  /*position: absolute;*/
  width: 443px;
  height: 84px;
  left: 0px;
  top: 48px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 28px;

  color: #ffffff;
}

.simepar-subtitle {
  /*position: absolute;*/
  width: 257px;
  height: 25px;
  left: 0px;
  top: 176px;

  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 28px;

  display: flex;
  align-items: center;

  color: #ffffff;
}

.simepar-subtitle-text {
  /*position: absolute;*/
  width: 442px;
  /*height: 196px;*/
  left: 1px;
  top: 214px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 24px;

  color: #ffffff;
}

.v-icon {
  position: absolute;
  font-size: 5px;
  margin-top: 10px;
  margin-left: -15px;
}
</style>
